import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f9d9bdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-bp-title" }, "📦 Batch Processor", -1 /* HOISTED */))
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "nge-bp-flash"
}
const _hoisted_4 = { class: "nge-bp-create" }
const _hoisted_5 = ["onKeydown"]
const _hoisted_6 = {
  key: 0,
  class: "nge-bp-progress"
}
const _hoisted_7 = { class: "nge-bp-progress-label" }
const _hoisted_8 = { class: "nge-bp-progress-bar" }
const _hoisted_9 = {
  key: 1,
  class: "nge-bp-list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "nge-bp-dataset-name" }
const _hoisted_12 = {
  key: 0,
  class: "nge-bp-dataset-tag nge-bp-dataset-tag--current"
}
const _hoisted_13 = {
  key: 1,
  class: "nge-bp-dataset-tag nge-bp-dataset-tag--other"
}
const _hoisted_14 = { class: "nge-bp-dataset-count" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "nge-bp-group-chevron" }
const _hoisted_17 = { class: "nge-bp-group-name" }
const _hoisted_18 = { class: "nge-bp-group-count" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-bp-group-spacer" }, null, -1 /* HOISTED */))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "nge-bp-group-body"
}
const _hoisted_22 = { class: "nge-bp-rename" }
const _hoisted_23 = ["value", "onChange"]
const _hoisted_24 = {
  key: 0,
  class: "nge-bp-chips"
}
const _hoisted_25 = ["title", "onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  width: "10",
  height: "10",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 1.6a4.3 4.3 0 0 1 4.3 4.3c0 3-4.3 7.5-4.3 7.5S3.7 8.9 3.7 5.9A4.3 4.3 0 0 1 8 1.6z",
    stroke: "currentColor",
    "stroke-width": "1.6"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8",
    cy: "5.9",
    r: "1.5",
    fill: "currentColor"
  })
], -1 /* HOISTED */))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  class: "nge-bp-empty-segs"
}
const _hoisted_30 = { class: "nge-bp-add-row" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onUpdate:modelValue", "onKeydown"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "nge-bp-point-row" }
const _hoisted_35 = ["disabled", "onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  width: "12",
  height: "12",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 1.6a4.3 4.3 0 0 1 4.3 4.3c0 3-4.3 7.5-4.3 7.5S3.7 8.9 3.7 5.9A4.3 4.3 0 0 1 8 1.6z",
    stroke: "currentColor",
    "stroke-width": "1.6"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8",
    cy: "5.9",
    r: "1.5",
    fill: "currentColor"
  })
], -1 /* HOISTED */))
const _hoisted_37 = {
  key: 0,
  class: "nge-bp-point-count"
}
const _hoisted_38 = { class: "nge-bp-actions" }
const _hoisted_39 = ["onClick", "disabled"]
const _hoisted_40 = ["onClick", "disabled"]
const _hoisted_41 = ["onClick", "disabled"]
const _hoisted_42 = ["onClick", "disabled"]
const _hoisted_43 = ["onClick", "disabled"]
const _hoisted_44 = {
  key: 2,
  class: "nge-bp-sub"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-bp-sub-label" }, "Pick color:", -1 /* HOISTED */))
const _hoisted_46 = { class: "nge-bp-swatches" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onChange"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  key: 3,
  class: "nge-bp-sub"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-bp-sub-label" }, "Cell type:", -1 /* HOISTED */))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select type...", -1 /* HOISTED */))
const _hoisted_53 = ["value"]
const _hoisted_54 = ["onClick", "disabled"]
const _hoisted_55 = { class: "nge-bp-sub-note" }
const _hoisted_56 = {
  key: 4,
  class: "nge-bp-confirm"
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "nge-bp-confirm-btns" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = {
  key: 5,
  class: "nge-bp-guide"
}
const _hoisted_61 = {
  key: 0,
  class: "nge-bp-guide-intro"
}
const _hoisted_62 = { class: "nge-bp-guide-title" }
const _hoisted_63 = {
  key: 0,
  class: "nge-bp-guide-text",
  role: "status"
}
const _hoisted_64 = {
  key: 1,
  class: "nge-bp-guide-text"
}
const _hoisted_65 = {
  key: 2,
  class: "nge-bp-guide-text"
}
const _hoisted_66 = {
  key: 3,
  class: "nge-bp-guide-text"
}
const _hoisted_67 = { class: "nge-bp-guide-actions" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["disabled", "onClick"]
const _hoisted_70 = { class: "nge-bp-guide-walk" }
const _hoisted_71 = { class: "nge-bp-guide-stepper" }
const _hoisted_72 = { class: "nge-bp-guide-segid" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
], -1 /* HOISTED */))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "nge-bp-guide-status" }
const _hoisted_77 = {
  key: 0,
  class: "nge-bp-guide-saved"
}
const _hoisted_78 = {
  key: 1,
  class: "nge-bp-guide-skipped"
}
const _hoisted_79 = {
  key: 2,
  class: "nge-bp-guide-pending"
}
const _hoisted_80 = { class: "nge-bp-guide-solo" }
const _hoisted_81 = ["checked", "onChange"]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hide other cells", -1 /* HOISTED */))
const _hoisted_83 = { class: "nge-bp-guide-actions" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { class: "nge-bp-guide-nav" }
const _hoisted_88 = ["onClick", "disabled"]
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "nge-bp-guide-review" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-bp-guide-title" }, "Ready to submit", -1 /* HOISTED */))
const _hoisted_92 = { class: "nge-bp-guide-summary" }
const _hoisted_93 = { class: "nge-bp-guide-list" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "nge-bp-guide-item-pip" }
const _hoisted_96 = { class: "nge-bp-guide-item-id" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
], -1 /* HOISTED */))
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = { class: "nge-bp-guide-actions" }
const _hoisted_101 = ["onClick", "disabled"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-bp-empty" }, " No groups yet. Create one above to batch-process segments. ", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "nge-bp",
      appear: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "nge-bp-panel",
          style: _normalizeStyle($setup.panelStyle)
        }, [
          _createCommentVNode(" Top bar "),
          _createElementVNode("div", {
            class: _normalizeClass(["nge-bp-topbar", { 'nge-bp-dragging': $setup.isDragging }]),
            onMousedown: $setup.startDrag
          }, [
            _hoisted_1,
            _createElementVNode("button", {
              class: "nge-bp-preview",
              onClick: _withModifiers($setup.previewBatchCelebration, ["stop"]),
              title: "Preview batch celebration"
            }, "🎉", 8 /* PROPS */, _hoisted_2),
            _createElementVNode("button", {
              class: "nge-bp-close",
              onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
            }, "×")
          ], 34 /* CLASS, HYDRATE_EVENTS */),
          _createCommentVNode(" Flash message "),
          _createVNode(_Transition, { name: "nge-bp-flash" }, {
            default: _withCtx(() => [
              ($setup.flashMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.flashMessage), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" Create group "),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.newGroupName) = $event)),
              placeholder: "Group name...",
              class: "nge-bp-input",
              onKeydown: [
                _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                _withKeys(_withModifiers($setup.createGroup, ["prevent"]), ["enter"])
              ],
              onKeyup: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
              onKeypress: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5), [
              [_vModelText, $setup.newGroupName]
            ]),
            _createElementVNode("button", {
              class: "nge-bp-btn nge-bp-btn--create",
              onClick: $setup.createGroup
            }, "+ Group")
          ]),
          _createCommentVNode(" Progress bar "),
          ($setup.batchProgress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString($setup.batchProgress.action === 'complete' ? 'Completing' : 'Annotating') + " " + _toDisplayString($setup.batchProgress.current) + "/" + _toDisplayString($setup.batchProgress.total) + "… ", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "nge-bp-progress-fill",
                    style: _normalizeStyle({ width: ($setup.batchProgress.current / $setup.batchProgress.total * 100) + '%' })
                  }, null, 4 /* STYLE */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Group list, sectioned by dataset "),
          ($setup.groups.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupsByDataset, (section) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: section.dataset,
                    class: _normalizeClass(["nge-bp-dataset-section", { 'nge-bp-dataset-section--cross': !section.isCurrent }])
                  }, [
                    _createElementVNode("div", {
                      class: "nge-bp-dataset-header",
                      onClick: $event => ($setup.toggleDatasetSection(section.dataset))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["nge-bp-dataset-arrow", { 'nge-bp-dataset-arrow--collapsed': $setup.collapsedDatasets.has(section.dataset) }])
                      }, "▾", 2 /* CLASS */),
                      _createElementVNode("span", _hoisted_11, [
                        _createTextVNode(_toDisplayString(section.label) + " ", 1 /* TEXT */),
                        (section.isCurrent)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "current"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13, "other dataset"))
                      ]),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(section.groups.length), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_10),
                    (!$setup.collapsedDatasets.has(section.dataset))
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(section.groups, (group) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: group.id,
                            class: "nge-bp-group"
                          }, [
                            _createCommentVNode(" Group header "),
                            _createElementVNode("div", {
                              class: "nge-bp-group-header",
                              onClick: $event => ($setup.toggleExpand(group.id))
                            }, [
                              (group.color)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "nge-bp-group-color",
                                    style: _normalizeStyle({ background: group.color })
                                  }, null, 4 /* STYLE */))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("span", _hoisted_16, _toDisplayString($setup.expandedGroupId === group.id ? '▾' : '▸'), 1 /* TEXT */),
                              _createElementVNode("span", _hoisted_17, _toDisplayString(group.name), 1 /* TEXT */),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(group.segmentIds.length), 1 /* TEXT */),
                              _hoisted_19,
                              _createElementVNode("button", {
                                class: "nge-bp-group-del",
                                onClick: _withModifiers($event => ($setup.deleteGroup(group.id)), ["stop"]),
                                title: "Delete group"
                              }, "×", 8 /* PROPS */, _hoisted_20)
                            ], 8 /* PROPS */, _hoisted_15),
                            _createCommentVNode(" Expanded content "),
                            ($setup.expandedGroupId === group.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createCommentVNode(" Rename "),
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("input", {
                                      value: group.name,
                                      onChange: $event => ($setup.renameGroup(group, $setup.inputValue($event))),
                                      class: "nge-bp-input nge-bp-input--sm",
                                      placeholder: "Rename...",
                                      onKeydown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                                      onKeyup: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                                      onKeypress: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_23)
                                  ]),
                                  _createCommentVNode(" Segment chips "),
                                  (group.segmentIds.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.segmentIds, (segId) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: segId,
                                            class: _normalizeClass(["nge-bp-chip", { 'nge-bp-chip--pointed': $setup.hasSavedPoint(segId) }])
                                          }, [
                                            ($setup.hasSavedPoint(segId))
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: "nge-bp-chip-pin",
                                                  title: $setup.pointTip(segId),
                                                  "aria-label": "Remove this cell's saved point",
                                                  onClick: _withModifiers($event => ($setup.forgetCellPoint(segId)), ["stop"])
                                                }, _hoisted_27, 8 /* PROPS */, _hoisted_25))
                                              : _createCommentVNode("v-if", true),
                                            _createTextVNode(" " + _toDisplayString($setup.truncId(segId)) + " ", 1 /* TEXT */),
                                            _createElementVNode("button", {
                                              class: "nge-bp-chip-x",
                                              onClick: $event => ($setup.removeSegment(group, segId))
                                            }, "×", 8 /* PROPS */, _hoisted_28)
                                          ], 2 /* CLASS */))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_29, "No segments — add some below")),
                                  _createCommentVNode(" Add segments "),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("button", {
                                      class: "nge-bp-btn nge-bp-btn--add",
                                      onClick: $event => ($setup.addAllVisible(group))
                                    }, "+ All Visible", 8 /* PROPS */, _hoisted_31),
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": $event => (($setup.addSegInput[group.id]) = $event),
                                      placeholder: "Paste IDs...",
                                      class: "nge-bp-input nge-bp-input--sm nge-bp-input--flex",
                                      onKeydown: [
                                        _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                                        _withKeys(_withModifiers($event => ($setup.addById(group)), ["prevent"]), ["enter"])
                                      ],
                                      onKeyup: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                                      onKeypress: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_32), [
                                      [_vModelText, $setup.addSegInput[group.id]]
                                    ]),
                                    _createElementVNode("button", {
                                      class: "nge-bp-btn nge-bp-btn--add",
                                      onClick: $event => ($setup.addById(group))
                                    }, "Add", 8 /* PROPS */, _hoisted_33)
                                  ]),
                                  _createCommentVNode(" Save a point for the cell you are on (Ames 2026-10-07) "),
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("button", {
                                      class: "nge-bp-btn nge-bp-btn--point",
                                      disabled: $setup.savingPointFor === group.id,
                                      onClick: $event => ($setup.savePointHere(group)),
                                      title: "Put the crosshairs inside a cell, then press this. The cell is labelled with that point, and batch complete will use it."
                                    }, [
                                      _hoisted_36,
                                      _createTextVNode(" " + _toDisplayString($setup.savingPointFor === group.id ? 'Checking the cell…' : 'Save point for the cell at the crosshairs'), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_35),
                                    (group.segmentIds.length)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString($setup.savedPointCount(group)) + " of " + _toDisplayString(group.segmentIds.length) + " have a point", 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _createCommentVNode(" Action bar "),
                                  _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("button", {
                                      class: "nge-bp-act nge-bp-act--color",
                                      onClick: _withModifiers($event => ($setup.colorPickerGroupId = $setup.colorPickerGroupId === group.id ? null : group.id), ["stop"]),
                                      disabled: group.segmentIds.length === 0
                                    }, " 🎨 Recolor ", 8 /* PROPS */, _hoisted_39),
                                    _createElementVNode("button", {
                                      class: "nge-bp-act nge-bp-act--complete",
                                      onClick: _withModifiers($event => ($setup.startCompleteWizard(group)), ["stop"]),
                                      disabled: group.segmentIds.length === 0
                                    }, " ✓ Proofread ", 8 /* PROPS */, _hoisted_40),
                                    _createElementVNode("button", {
                                      class: "nge-bp-act nge-bp-act--annotate",
                                      onClick: _withModifiers($event => {$setup.annotateGroupId = $setup.annotateGroupId === group.id ? null : group.id; $setup.selectedCellType = ''}, ["stop"]),
                                      disabled: group.segmentIds.length === 0
                                    }, " 🏷 Annotate ", 8 /* PROPS */, _hoisted_41),
                                    _createElementVNode("button", {
                                      class: "nge-bp-act nge-bp-act--copy",
                                      onClick: $event => ($setup.batchCopy(group)),
                                      disabled: group.segmentIds.length === 0
                                    }, " 📋 Copy ", 8 /* PROPS */, _hoisted_42),
                                    _createElementVNode("button", {
                                      class: "nge-bp-act nge-bp-act--remove",
                                      onClick: _withModifiers($event => ($setup.confirmAction = { groupId: group.id, action: 'remove' }), ["stop"]),
                                      disabled: group.segmentIds.length === 0
                                    }, " 🗑 Remove ", 8 /* PROPS */, _hoisted_43)
                                  ]),
                                  _createCommentVNode(" Color picker sub-panel "),
                                  ($setup.colorPickerGroupId === group.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                        _hoisted_45,
                                        _createElementVNode("div", _hoisted_46, [
                                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['#FF6B6B','#FFA726','#FFD700','#66BB6A','#42A5F5','#CE93D8','#26C6DA','#EF5350','#FFFFFF'], (c) => {
                                            return _createElementVNode("button", {
                                              key: c,
                                              class: "nge-bp-swatch",
                                              style: _normalizeStyle({ background: c }),
                                              onClick: $event => ($setup.batchRecolor(group, c))
                                            }, null, 12 /* STYLE, PROPS */, _hoisted_47)
                                          }), 64 /* STABLE_FRAGMENT */))
                                        ]),
                                        _createElementVNode("input", {
                                          type: "color",
                                          class: "nge-bp-color-input",
                                          onChange: $event => ($setup.batchRecolor(group, $setup.inputValue($event)))
                                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_48),
                                        (group.color)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "nge-bp-btn nge-bp-btn--sm",
                                              onClick: $event => ($setup.resetGroupColors(group))
                                            }, "Reset Colors", 8 /* PROPS */, _hoisted_49))
                                          : _createCommentVNode("v-if", true)
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  _createCommentVNode(" Annotate sub-panel "),
                                  ($setup.annotateGroupId === group.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                        _hoisted_51,
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.selectedCellType) = $event)),
                                          class: "nge-bp-select",
                                          onKeydown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
                                          onKeyup: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"])),
                                          onKeypress: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
                                        }, [
                                          _hoisted_52,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentCellTypes(), (ct) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: ct,
                                              value: ct
                                            }, _toDisplayString($setup.cellTypeLabel(ct)), 9 /* TEXT, PROPS */, _hoisted_53))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                          [_vModelSelect, $setup.selectedCellType]
                                        ]),
                                        _createElementVNode("button", {
                                          class: "nge-bp-btn nge-bp-btn--go",
                                          onClick: $event => ($setup.batchAnnotate(group)),
                                          disabled: !$setup.selectedCellType
                                        }, "Apply", 8 /* PROPS */, _hoisted_54),
                                        _createCommentVNode(" Each cell is typed at its own saved point; say how many have one. "),
                                        _createElementVNode("div", _hoisted_55, _toDisplayString($setup.pointCount(group)) + " of " + _toDisplayString(group.segmentIds.length) + " have a saved point. A cell is typed at its own point, so one without a point is skipped: put the crosshairs inside it and press Save point. ", 1 /* TEXT */)
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  _createCommentVNode(" Confirm dialog (used for 'remove' only — 'complete' uses the guided wizard) "),
                                  ($setup.confirmAction && $setup.confirmAction.groupId === group.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                        ($setup.confirmAction.action === 'remove')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_57, " Remove " + _toDisplayString(group.segmentIds.length) + " segments from viewer? ", 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", _hoisted_58, [
                                          _createElementVNode("button", {
                                            class: "nge-bp-btn nge-bp-btn--go",
                                            onClick: $event => ($setup.batchRemoveFromViewer(group))
                                          }, "Yes", 8 /* PROPS */, _hoisted_59),
                                          _createElementVNode("button", {
                                            class: "nge-bp-btn nge-bp-btn--sm",
                                            onClick: _cache[15] || (_cache[15] = $event => ($setup.confirmAction = null))
                                          }, "Cancel")
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  _createCommentVNode(" ── Guided \"Mark Complete\" wizard ── "),
                                  ($setup.guide && $setup.guide.groupId === group.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                        _createCommentVNode(" Stage 1: Intro "),
                                        ($setup.guide.stage === 'intro')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                              _createElementVNode("div", _hoisted_62, _toDisplayString($setup.guide.finding ? 'Checking your saved points' : $setup.pendingCount(group) === 0 ? 'Every cell has a point' : 'Place crosshairs in each cell'), 1 /* TEXT */),
                                              _createCommentVNode(" Points you saved while working (Ames 2026-10-07) "),
                                              ($setup.guide.finding)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_63, " Making sure each point you saved is still inside its cell" + _toDisplayString($setup.guide.finding.total ? ` (${$setup.guide.finding.done} of ${$setup.guide.finding.total} checked)` : '') + ". ", 1 /* TEXT */))
                                                : ($setup.guide.auto.size > 0 && $setup.pendingCount(group) === 0)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_64, " All " + _toDisplayString(group.segmentIds.length) + " cells have the point you saved for them, and each is still inside its cell. Nothing to place. ", 1 /* TEXT */))
                                                  : ($setup.guide.auto.size > 0)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString($setup.guide.auto.size) + " of " + _toDisplayString(group.segmentIds.length) + " cells have the point you saved for them. " + _toDisplayString($setup.pendingCount(group)) + " still " + _toDisplayString($setup.pendingCount(group) === 1 ? 'needs' : 'need') + " one: place the crosshairs inside " + _toDisplayString($setup.pendingCount(group) === 1 ? 'it' : 'each') + ". ", 1 /* TEXT */))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_66, " To mark " + _toDisplayString(group.segmentIds.length) + " cells as proofread, you'll place crosshairs inside each one so CAVE can map points to the right segment. Each cell needs its own point. ", 1 /* TEXT */)),
                                              _createElementVNode("div", _hoisted_67, [
                                                _createElementVNode("button", {
                                                  class: "nge-bp-btn nge-bp-btn--sm",
                                                  onClick: $event => ($setup.loadAllSegmentsIntoViewer(group))
                                                }, "Load all into viewer", 8 /* PROPS */, _hoisted_68),
                                                (!$setup.guide.finding && $setup.pendingCount(group) === 0)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 0,
                                                      class: "nge-bp-btn nge-bp-btn--go",
                                                      onClick: _cache[16] || (_cache[16] = $event => ($setup.guide.stage = 'review'))
                                                    }, "Review →"))
                                                  : (_openBlock(), _createElementBlock("button", {
                                                      key: 1,
                                                      class: "nge-bp-btn nge-bp-btn--go",
                                                      disabled: !!$setup.guide.finding,
                                                      onClick: $event => ($setup.startWalk(group))
                                                    }, "Start →", 8 /* PROPS */, _hoisted_69)),
                                                _createElementVNode("button", {
                                                  class: "nge-bp-btn nge-bp-btn--sm",
                                                  onClick: $setup.cancelCompleteWizard
                                                }, "Cancel")
                                              ])
                                            ]))
                                          : ($setup.guide.stage === 'walk')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createCommentVNode(" Stage 2: Walk "),
                                                _createElementVNode("div", _hoisted_70, [
                                                  _createElementVNode("div", _hoisted_71, [
                                                    _createTextVNode(" Cell " + _toDisplayString($setup.guide.index + 1) + " of " + _toDisplayString(group.segmentIds.length) + " · ", 1 /* TEXT */),
                                                    _createElementVNode("span", {
                                                      class: "nge-bp-guide-color",
                                                      style: _normalizeStyle({ background: $setup.getSegmentColor(group.segmentIds[$setup.guide.index]) })
                                                    }, null, 4 /* STYLE */),
                                                    _createElementVNode("span", _hoisted_72, _toDisplayString($setup.truncId(group.segmentIds[$setup.guide.index])), 1 /* TEXT */),
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-guide-copy",
                                                      onClick: $event => ($setup.copySegId(group.segmentIds[$setup.guide.index])),
                                                      title: "Copy full ID",
                                                      "aria-label": "Copy segment ID"
                                                    }, _hoisted_75, 8 /* PROPS */, _hoisted_73)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_76, [
                                                    ($setup.segStatus(group.segmentIds[$setup.guide.index]) === 'saved')
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString($setup.guide.auto.has(group.segmentIds[$setup.guide.index]) ? '✓ Your saved point' : '✓ Saved'), 1 /* TEXT */))
                                                      : ($setup.segStatus(group.segmentIds[$setup.guide.index]) === 'skipped')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_78, "— Skipped"))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_79, "Place crosshairs in the cell"))
                                                  ]),
                                                  _createElementVNode("label", _hoisted_80, [
                                                    _createElementVNode("input", {
                                                      type: "checkbox",
                                                      checked: $setup.guide.solo,
                                                      onChange: $event => ($setup.toggleSolo(group))
                                                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_81),
                                                    _hoisted_82
                                                  ]),
                                                  _createElementVNode("div", _hoisted_83, [
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--sm",
                                                      onClick: $event => ($setup.jumpToCurrentSegment(group))
                                                    }, "Show in viewer", 8 /* PROPS */, _hoisted_84),
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--go",
                                                      onClick: $event => ($setup.saveCurrentPoint(group))
                                                    }, "Save Point", 8 /* PROPS */, _hoisted_85),
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--sm",
                                                      onClick: $event => ($setup.skipCurrent(group))
                                                    }, "Skip", 8 /* PROPS */, _hoisted_86)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_87, [
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--sm",
                                                      onClick: $event => ($setup.prevSegment(group)),
                                                      disabled: $setup.guide.index === 0
                                                    }, "◂ Prev", 8 /* PROPS */, _hoisted_88),
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--sm",
                                                      onClick: $event => ($setup.nextSegment(group))
                                                    }, _toDisplayString($setup.nextPendingIndex(group, $setup.guide.index + 1) < 0 ? 'Review →' : 'Next ▸'), 9 /* TEXT, PROPS */, _hoisted_89),
                                                    _createElementVNode("button", {
                                                      class: "nge-bp-btn nge-bp-btn--sm",
                                                      onClick: $setup.cancelCompleteWizard
                                                    }, "Cancel")
                                                  ])
                                                ])
                                              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                            : ($setup.guide.stage === 'review')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                  _createCommentVNode(" Stage 3: Review "),
                                                  _createElementVNode("div", _hoisted_90, [
                                                    _hoisted_91,
                                                    _createElementVNode("div", _hoisted_92, [
                                                      _createTextVNode(_toDisplayString(Object.keys($setup.guide.points).length) + " ready", 1 /* TEXT */),
                                                      ($setup.guide.auto.size)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createTextVNode(" (" + _toDisplayString($setup.guide.auto.size) + " saved earlier)", 1 /* TEXT */)
                                                          ], 64 /* STABLE_FRAGMENT */))
                                                        : _createCommentVNode("v-if", true),
                                                      _createTextVNode(" · " + _toDisplayString($setup.guide.skipped.size) + " skipped · " + _toDisplayString(group.segmentIds.length - Object.keys($setup.guide.points).length - $setup.guide.skipped.size) + " pending ", 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_93, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.segmentIds, (segId, i) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          key: segId,
                                                          class: _normalizeClass(["nge-bp-guide-item", `nge-bp-guide-item--${$setup.segStatus(segId)}`]),
                                                          onClick: $event => ($setup.gotoSegment(group, i))
                                                        }, [
                                                          _createElementVNode("span", _hoisted_95, _toDisplayString($setup.segStatus(segId) === 'saved' ? '✓' : $setup.segStatus(segId) === 'skipped' ? '—' : '?'), 1 /* TEXT */),
                                                          _createElementVNode("span", {
                                                            class: "nge-bp-guide-item-color",
                                                            style: _normalizeStyle({ background: $setup.getSegmentColor(segId) })
                                                          }, null, 4 /* STYLE */),
                                                          _createElementVNode("span", _hoisted_96, _toDisplayString($setup.truncId(segId)), 1 /* TEXT */),
                                                          _createElementVNode("button", {
                                                            class: "nge-bp-guide-copy",
                                                            onClick: _withModifiers($event => ($setup.copySegId(segId)), ["stop"]),
                                                            title: "Copy full ID",
                                                            "aria-label": "Copy segment ID"
                                                          }, _hoisted_99, 8 /* PROPS */, _hoisted_97)
                                                        ], 10 /* CLASS, PROPS */, _hoisted_94))
                                                      }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_100, [
                                                      _createElementVNode("button", {
                                                        class: "nge-bp-btn nge-bp-btn--sm",
                                                        onClick: _cache[17] || (_cache[17] = $event => ($setup.guide.stage = 'walk'))
                                                      }, "◂ Back to walk"),
                                                      _createElementVNode("button", {
                                                        class: "nge-bp-btn nge-bp-btn--go",
                                                        onClick: $event => ($setup.submitGuidedComplete(group)),
                                                        disabled: Object.keys($setup.guide.points).length === 0
                                                      }, " Submit (" + _toDisplayString(Object.keys($setup.guide.points).length) + ") ", 9 /* TEXT, PROPS */, _hoisted_101),
                                                      _createElementVNode("button", {
                                                        class: "nge-bp-btn nge-bp-btn--sm",
                                                        onClick: $setup.cancelCompleteWizard
                                                      }, "Cancel")
                                                    ])
                                                  ])
                                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                              : _createCommentVNode("v-if", true)
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createCommentVNode(" Empty state "),
                _hoisted_102
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        ], 4 /* STYLE */)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}